<svg
  width="16"
  height="15"
  viewBox="0 0 16 15"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_5276_5973)">
    <rect
      width="5"
      height="13"
      transform="matrix(1 8.74228e-08 8.74228e-08 -1 10 13.8699)"
      fill="currentColor"
    />
  </g>
  <rect
    x="15.3"
    y="13.54"
    width="14.6"
    height="12.6"
    rx="1.3"
    transform="rotate(-180 15.3 13.54)"
    stroke="currentColor"
    stroke-width="1.4"
  />
  <defs>
    <clipPath id="clip0_5276_5973">
      <rect
        x="16"
        y="14.24"
        width="16"
        height="14"
        rx="2"
        transform="rotate(-180 16 14.24)"
        fill="white"
      />
    </clipPath>
  </defs>
</svg>
